'use client';

import type { ReactNode } from 'react';
import { useStore } from 'zustand';

import { authStore } from '@/store/auth.store';

export function HideWhenLoggedIn({ children, enabled = true }: { children: ReactNode; enabled?: boolean }) {
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);

  if (enabled && isLoggedIn) {
    return null;
  }

  return <>{children}</>;
}
